import MegaOptionContainer from '../../../../Componant/Forms/FormsControl/MegaOption/MegaOption'

const MegaOption = () => {
  return (
    <div className='page-body'>
      <MegaOptionContainer />
    </div>
  )
}

export default MegaOption